module.exports = __webpack_public_path__ + "static/media/AdityaNaikResume.5b67b185.pdf";